import { render, staticRenderFns } from "./PlayPage.vue?vue&type=template&id=cb74b926&"
import script from "./PlayPage.vue?vue&type=script&lang=js&"
export * from "./PlayPage.vue?vue&type=script&lang=js&"
import style0 from "./PlayPage.vue?vue&type=style&index=0&id=cb74b926&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports